import API from '..';
const ENTITY = 'international';

export const getLanguages = () => API.get(`/api/v1/${ENTITY}/languages/`);
export const getTimezones = () => API.get(`/api/v1/${ENTITY}/timezones/`);
